import { useLocation, useNavigate } from "react-router-dom";
import type { NavItem } from "@/lib/navigation";
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";

export function NavSecondary({
  items,
  label = "Workspace",
  className,
  labelClassName,
}: {
  items: NavItem[];
  label?: string;
  className?: string;
  labelClassName?: string;
}) {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <SidebarGroup className={className}>
      <SidebarGroupLabel className="uppercase text-xs">{label}</SidebarGroupLabel>
      <SidebarGroupContent>
        <SidebarMenu>
          {items.map((item) => {
            const isActive = location.pathname === item.url || location.pathname.startsWith(item.url + "/");
            const Icon = item.icon;
            return (
              <SidebarMenuItem key={item.title}>
                <SidebarMenuButton
                  isActive={isActive}
                  onClick={() => navigate(item.url)}
                  title={item.title}
                >
                  {Icon && <Icon />}
                  <span className={labelClassName}>{item.title}</span>
                </SidebarMenuButton>
              </SidebarMenuItem>
            );
          })}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
